const _excluded = ["legalTermsOld"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compact } from 'lodash-es';
import { notEmpty } from "../infra/utils";
import { fromDatestampObjectToExpirationDate } from "./expiration-date";
import * as legalTermsModel from "./legal-terms";
import * as serviceModel from "./service";
import { formatDateLong, fromDateStampObject } from "./time";
import { approvalMethodNoticePeriodModel, introVideoModel } from '.';
export let DraftStatusType = /*#__PURE__*/function (DraftStatusType) {
  DraftStatusType["Active"] = "active";
  DraftStatusType["Scheduled"] = "scheduled";
  DraftStatusType["Archived"] = "archived";
  DraftStatusType["None"] = "none";
  return DraftStatusType;
}({});
export class DraftModel {
  static fromDTO(dto) {
    var _dto$legalTermsDocume;
    return new DraftModel(_objectSpread(_objectSpread({}, dto), {}, {
      legalTermsOld: dto.legalTerms,
      // @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged
      legalTermsDocuments: (_dto$legalTermsDocume = dto.legalTermsDocuments) !== null && _dto$legalTermsDocume !== void 0 ? _dto$legalTermsDocume : [],
      metadata: dto.metadata,
      services: compact(dto.services.map(serviceModel.fromDTO)),
      serviceBundles: dto.serviceBundles ? {
        bundles: dto.serviceBundles.bundles.map(bundle => _objectSpread(_objectSpread({}, bundle), {}, {
          services: compact(bundle.services.map(serviceModel.fromDTO))
        }))
      } : undefined
    }));
  }
  static fromRelationship(relationship, legalTermsDocIds) {
    return new DraftModel({
      id: relationship.id,
      coverLetter: relationship.customNotificationText,
      extraClause: relationship.extraClause || '',
      requirePaymentMethod: relationship.requirePaymentMethod != null ? relationship.requirePaymentMethod : true,
      allowManualPayments: relationship.allowManualPayments,
      isExistingCustomer: false,
      customNotificationText: relationship.customNotificationText,
      title: relationship.title,
      lastModifiedOn: 0,
      lastModifiedBy: null,
      services: relationship.services,
      serviceBundles: relationship.serviceBundles,
      netTerms: relationship.netTerms,
      effectiveDate: relationship.effectiveDate,
      feeControls: relationship.feeControls,
      clientContactId: relationship.clientContactId,
      isSample: relationship.isSample,
      amendmentsApprovalMethod: relationship.amendmentsApprovalMethod,
      invoicesApprovalMethod: relationship.invoicesApprovalMethod,
      requestAccountantAccess: relationship.requestAccountantAccess,
      introVideo: relationship.introVideo,
      expirationDate: fromDatestampObjectToExpirationDate(relationship.expirationDate, relationship.createdOn),
      legalTermsOld: legalTermsModel.toDraftLegalTermsOld(relationship.legalTerms, !legalTermsDocIds.includes(relationship.legalTerms.id)),
      legalTermsDocuments: relationship.legalTermsDocuments,
      reviewers: [...(relationship.signatories || []).map(s => ({
        firstName: s.firstName || undefined,
        lastName: s.lastName || undefined,
        email: s.email,
        isSignatory: true
      })), ...relationship.reviewers.map(r => ({
        firstName: r.firstName || undefined,
        lastName: r.lastName || undefined,
        email: r.email,
        isSignatory: false
      }))],
      metadata: undefined,
      status: {
        type: DraftStatusType.Active
      }
    });
  }
  constructor(data) {
    this.data = data;
  }
  toDTO() {
    var _ref, _this$data$legalTerms;
    const _this$data = this.data,
      {
        legalTermsOld: _legalTermsOld
      } = _this$data,
      rest = _objectWithoutProperties(_this$data, _excluded);
    return _objectSpread(_objectSpread({}, rest), {}, {
      services: this.data.services.map(serviceModel.toDTO),
      legalTerms: this.data.legalTermsOld,
      // @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged
      legalTermsDocuments: (_ref = (_this$data$legalTerms = this.data.legalTermsDocuments) === null || _this$data$legalTerms === void 0 ? void 0 : _this$data$legalTerms.filter(notEmpty)) !== null && _ref !== void 0 ? _ref : null,
      serviceBundles: this.data.serviceBundles != null ? {
        bundles: this.data.serviceBundles.bundles.map(bundle => _objectSpread(_objectSpread({}, bundle), {}, {
          services: bundle.services.map(serviceModel.toDTO)
        }))
      } : undefined
    });
  }
  id() {
    return this.data.id;
  }
  coverLetter() {
    return this.data.coverLetter;
  }
  extraClause() {
    return this.data.extraClause;
  }
  requirePaymentMethod() {
    return this.data.requirePaymentMethod;
  }
  allowWithoutPaymentMethod() {
    return !this.data.requirePaymentMethod;
  }
  allowManualPayments() {
    return this.data.allowManualPayments;
  }
  isExistingCustomer() {
    return this.data.isExistingCustomer;
  }
  customNotificationText() {
    return this.data.customNotificationText;
  }
  title() {
    return this.data.title;
  }
  lastModifiedOn() {
    return this.data.lastModifiedOn;
  }
  lastModifiedBy() {
    return this.data.lastModifiedBy;
  }
  services() {
    return this.data.services;
  }
  serviceBundles() {
    return this.data.serviceBundles ? this.data.serviceBundles.bundles : [];
  }
  netTerms() {
    return this.data.netTerms;
  }
  effectiveDate() {
    return this.data.effectiveDate;
  }
  effectiveDateAsDate() {
    return this.data.effectiveDate ? fromDateStampObject(this.data.effectiveDate) : null;
  }
  formattedEffectiveDate() {
    return this.data.effectiveDate ? formatDateLong(this.data.effectiveDate) : null;
  }
  legalTermsOld() {
    return this.data.legalTermsOld;
  }
  legalTermsDocuments() {
    var _this$data$legalTerms2;
    return (_this$data$legalTerms2 = this.data.legalTermsDocuments) !== null && _this$data$legalTerms2 !== void 0 ? _this$data$legalTerms2 : [];
  }
  coverCreditCardFees() {
    return this.data.feeControls.coverCreditCardFees;
  }
  clientContactId() {
    return this.data.clientContactId;
  }
  isSample() {
    return this.data.isSample;
  }
  amendmentsApprovalMethod() {
    return this.data.amendmentsApprovalMethod;
  }
  invoicesApprovalMethod() {
    return this.data.invoicesApprovalMethod;
  }
  requestAccountantAccess() {
    return this.data.requestAccountantAccess;
  }
  reviewers() {
    return this.data.reviewers;
  }
  introVideo() {
    return this.data.introVideo;
  }
  introVideoLink() {
    return this.data.introVideo ? introVideoModel.videoUrl(this.data.introVideo) : null;
  }
  expirationDate() {
    return this.data.expirationDate;
  }
  metadata() {
    return this.data.metadata;
  }
  service(serviceId) {
    if (this.data.serviceBundles) {
      return this.data.serviceBundles.bundles.flatMap(b => b.services).find(s => s.id === serviceId);
    }
    return this.data.services.find(s => s.id === serviceId);
  }
  hasNoServicesOrBundles() {
    return !this.data.serviceBundles && !this.data.services.length;
  }
  expirationDaysAfterSending() {
    var _this$data$expiration;
    return ((_this$data$expiration = this.data.expirationDate) === null || _this$data$expiration === void 0 ? void 0 : _this$data$expiration.type) === 'days' ? this.data.expirationDate.days : null;
  }
  defaultExpirationDays(worksAt) {
    var _worksAt$settings;
    return (worksAt === null || worksAt === void 0 || (_worksAt$settings = worksAt.settings) === null || _worksAt$settings === void 0 || (_worksAt$settings = _worksAt$settings.expirationDate) === null || _worksAt$settings === void 0 ? void 0 : _worksAt$settings.type) === 'days' ? worksAt.settings.expirationDate.days : 30;
  }
  defaultAutoApprovalMethod(worksAt) {
    var _worksAt$settings2;
    return worksAt !== null && worksAt !== void 0 && (_worksAt$settings2 = worksAt.settings) !== null && _worksAt$settings2 !== void 0 && _worksAt$settings2.amendmentsApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.amendmentsApprovalMethod) && worksAt.settings.amendmentsApprovalMethod.type === 'auto' ? worksAt.settings.amendmentsApprovalMethod.auto.noticePeriodDays : 30;
  }
  defaultAutoApproveOutOfScopeCharges(worksAt) {
    var _worksAt$settings3;
    return worksAt !== null && worksAt !== void 0 && (_worksAt$settings3 = worksAt.settings) !== null && _worksAt$settings3 !== void 0 && _worksAt$settings3.invoicesApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.invoicesApprovalMethod) && worksAt.settings.invoicesApprovalMethod.type === 'auto' ? worksAt.settings.invoicesApprovalMethod.auto.noticePeriodDays : 30;
  }
  isScheduled() {
    return this.data.status.type === DraftStatusType.Scheduled;
  }
  scheduledDate() {
    return this.data.status.type === DraftStatusType.Scheduled ? this.data.status.schedule.time : null;
  }
  addServices(services, packageId) {
    if (packageId) {
      if (this.data.serviceBundles) {
        const newBundles = this.data.serviceBundles.bundles.map(b => {
          if (b.id === packageId) {
            return _objectSpread(_objectSpread({}, b), {}, {
              services: b.services.concat(services)
            });
          }
          return b;
        });
        return this.setServiceBundles(newBundles);
      } else {
        return this;
      }
    } else {
      return this.setServices(this.data.services.concat(services));
    }
  }
  setServices(services) {
    return this.setChanges({
      services
    });
  }
  setServiceBundles(bundles) {
    return this.setChanges({
      serviceBundles: bundles.length > 0 ? {
        bundles
      } : undefined
    });
  }
  setService(serviceId, transformer) {
    if (this.data.serviceBundles) {
      const newBundles = this.data.serviceBundles.bundles.map(b => _objectSpread(_objectSpread({}, b), {}, {
        services: b.services.map(s => s.id === serviceId ? transformer(s) : s)
      }));
      return this.setChanges({
        serviceBundles: {
          bundles: newBundles
        }
      });
    } else {
      return this.setChanges({
        services: this.data.services.map(s => s.id === serviceId ? transformer(s) : s)
      });
    }
  }
  removeService(serviceId) {
    if (this.data.serviceBundles) {
      return this.setChanges({
        serviceBundles: {
          bundles: this.data.serviceBundles.bundles.map(bundle => _objectSpread(_objectSpread({}, bundle), {}, {
            services: bundle.services.filter(s => s.id !== serviceId)
          }))
        }
      });
    }
    return this.setChanges({
      services: this.data.services.filter(s => s.id !== serviceId)
    });
  }
  setPackageName(packageId, packageName) {
    if (!this.data.serviceBundles) {
      return this;
    }
    return this.setChanges({
      serviceBundles: {
        bundles: this.data.serviceBundles.bundles.map(bundle => bundle.id === packageId ? _objectSpread(_objectSpread({}, bundle), {}, {
          name: packageName
        }) : bundle)
      }
    });
  }

  /** @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged */
  setLegalTermsOld(legalTerms) {
    return this.setChanges({
      legalTermsOld: legalTerms
    });
  }
  setLegalTermsDocuments(legalTermsDocuments) {
    return this.setChanges({
      legalTermsDocuments
    });
  }
  setRequirePaymentMethod(requirePaymentMethod) {
    return this.setChanges({
      requirePaymentMethod
    });
  }
  setNetTerms(netTerms) {
    return this.setChanges({
      netTerms
    });
  }
  setAllowManualPayments(allowManualPayments) {
    return this.setChanges({
      allowManualPayments
    });
  }
  setIntroVideo(introVideo) {
    return this.setChanges({
      introVideo
    });
  }
  setCustomNotificationText(customNotificationText) {
    return this.setChanges({
      customNotificationText
    });
  }
  setExpirationDate(expirationDate) {
    return this.setChanges({
      expirationDate
    });
  }
  setEffectiveDate(effectiveDate) {
    return this.setChanges({
      effectiveDate
    });
  }
  setCoverCreditCardFees(coverCreditCardFees) {
    return this.setChanges({
      feeControls: _objectSpread(_objectSpread({}, this.data.feeControls), {}, {
        coverCreditCardFees
      })
    });
  }
  setSampleContact() {
    return this.setChanges({
      clientContactId: null,
      isSample: true
    });
  }
  setClientContactId(clientContactId) {
    return this.setChanges({
      clientContactId,
      isSample: false
    });
  }
  setInvoicesApprovalMethod(invoicesApprovalMethod) {
    return this.setChanges({
      invoicesApprovalMethod
    });
  }
  setAmendmentsApprovalMethod(amendmentsApprovalMethod) {
    return this.setChanges({
      amendmentsApprovalMethod
    });
  }
  setExtraClause(extraClause) {
    return this.setChanges({
      extraClause
    });
  }
  setTitle(title) {
    return this.setChanges({
      title
    });
  }
  setReviewers(reviewers) {
    return this.setChanges({
      reviewers
    });
  }
  setLastModifiedOn(lastModifiedOn) {
    return this.setChanges({
      lastModifiedOn
    });
  }
  setId(id) {
    return this.setChanges({
      id
    });
  }
  setChanges(changes) {
    return new DraftModel(_objectSpread(_objectSpread(_objectSpread({}, this.data), changes), {}, {
      id: changes.id || this.data.id
    }));
  }
}